// extracted by mini-css-extract-plugin
export default {"noResultsText":"PieChartStatistics_noResultsText__z0eY6"};